import { NgxAddress } from '../../models/ngxAddress';

export function addressChange(event: any): NgxAddress {
  let city = '';
  let pinCode = '';
  let state = '';
  let area = '';
  let country = '';
  const lat: number = event.geometry.location.lat();
  const lng: number = event.geometry.location.lng();
  const address: string = event['formatted_address'];

  event.address_components.forEach((element: any) => {
    if (element.types[0] === 'sublocality_level_1') {
      area = element.long_name;
    }
    if (element.types[0] === 'administrative_area_level_1') {
      state = element.long_name;
    }
    if (element.types[0] === 'locality') {
      city = element.long_name;
    }
    if (element.types[0] === 'postal_code') {
      pinCode = element.long_name;
    }
    if (element.types[0] === 'country') {
      country = element.long_name;
    }
  });

  const data = {
    pinCode,
    state,
    city,
    area,
    country,
    lat,
    lng,
    address
  };

  return data;
}
